/* ============================================================
   SIGMA · Opciones que no existen

   Shopify evalúa la disponibilidad de cada opción solo contra las
   ANTERIORES. Con tres opciones (Talla, Versión, Parches) eso deja
   la primera siempre "disponible": una XXL existe en el catálogo,
   aunque no exista en XXL + Aficionado + UCL. El cliente la elegía
   y se estrellaba con "NO DISPONIBLE" después de tres clics.

   Aquí se marca cada valor contra TODAS las demás opciones elegidas.
   Se marca, no se deshabilita: quien quiera ver qué hay en esa talla
   debe poder pulsarla, y al hacerlo el resto se recalcula.
   ============================================================ */
(function () {
  'use strict';

  function iniciar(raiz) {
    var datos = raiz.querySelector('[data-sigma-combos]');
    if (!datos) return;

    var combos;
    try {
      combos = JSON.parse(datos.textContent);
    } catch (e) {
      return; // sin matriz no se marca nada; mejor eso que marcar de más
    }
    if (!combos || !combos.length) return;

    var grupos = Array.prototype.slice.call(
      raiz.querySelectorAll('fieldset.product-form__input')
    );
    if (!grupos.length) return;

    function elegidos() {
      return grupos.map(function (g) {
        var m = g.querySelector('input[type="radio"]:checked');
        if (m) return m.value;
        var sel = g.querySelector('select');
        return sel ? sel.value : null;
      });
    }

    function existe(pos, valor, sel) {
      for (var i = 0; i < combos.length; i++) {
        var c = combos[i];
        if (c[pos] !== valor) continue;
        var ok = true;
        for (var j = 0; j < grupos.length; j++) {
          // contra las demás opciones, no contra sí misma
          if (j === pos) continue;
          if (sel[j] != null && c[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }

    function marcar() {
      var sel = elegidos();
      grupos.forEach(function (g, pos) {
        g.querySelectorAll('input[type="radio"]').forEach(function (inp) {
          var hay = existe(pos, inp.value, sel);
          var lbl = g.querySelector('label[for="' + CSS.escape(inp.id) + '"]');
          inp.classList.toggle('sig-nodisp', !hay);
          if (lbl) lbl.classList.toggle('sig-nodisp', !hay);

          /* Además de tacharla, hay que ANUNCIARLA. Dawn ya trae el mecanismo:
             con la clase visually-disabled deja de ocultar el texto
             "Variante agotada o no disponible" que vive dentro de cada etiqueta.
             Sin esto, quien usa lector de pantalla oía "XXL" igual que el resto,
             la elegía y se topaba con el botón deshabilitado. */
          inp.classList.toggle('visually-disabled', !hay);
          inp.setAttribute('aria-describedby', inp.id + '-estado');
          if (!hay) inp.setAttribute('aria-disabled', 'true');
          else inp.removeAttribute('aria-disabled');
        });
      });
    }

    raiz.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"], select')) marcar();
    });
    marcar();
  }

  function arrancar() {
    document.querySelectorAll('variant-selects').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* Dawn vuelve a pintar el selector al cambiar de variante y se lleva las
     marcas; hay que rehacerlas cuando eso pasa. */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { arrancar(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
